'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';


// ---- SVG Icons ----
const DiscoverIcon = () => (
  <svg width="19" height="19" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="5" y="0" width="2" height="1"/><rect x="3" y="1" width="2" height="1"/><rect x="7" y="1" width="2" height="1"/>
    <rect x="2" y="2" width="1" height="1"/><rect x="9" y="2" width="1" height="1"/>
    <rect x="1" y="3" width="1" height="2"/><rect x="10" y="3" width="1" height="2"/>
    <rect x="0" y="5" width="1" height="2"/><rect x="11" y="5" width="1" height="2"/>
    <rect x="1" y="7" width="1" height="2"/><rect x="10" y="7" width="1" height="2"/>
    <rect x="2" y="9" width="1" height="1"/><rect x="9" y="9" width="1" height="1"/>
    <rect x="3" y="10" width="2" height="1"/><rect x="7" y="10" width="2" height="1"/>
    <rect x="5" y="11" width="2" height="1"/>
    <rect x="7" y="3" width="1" height="1"/><rect x="6" y="4" width="1" height="1"/>
    <rect x="5" y="5" width="2" height="2"/><rect x="5" y="7" width="1" height="1"/>
    <rect x="4" y="8" width="1" height="1"/>
  </svg>
);
const CollectionsIcon = () => (
  <svg width="19" height="19" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="1" y="1" width="4" height="4"/><rect x="7" y="1" width="4" height="4"/>
    <rect x="1" y="7" width="4" height="4"/><rect x="7" y="7" width="4" height="4"/>
  </svg>
);
const BridgeIcon = () => (
  <svg width="19" height="19" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="3" y="0" width="1" height="10"/><rect x="2" y="1" width="1" height="1"/>
    <rect x="4" y="1" width="1" height="1"/><rect x="1" y="2" width="1" height="1"/>
    <rect x="5" y="2" width="1" height="1"/><rect x="8" y="2" width="1" height="10"/>
    <rect x="7" y="9" width="1" height="1"/><rect x="9" y="9" width="1" height="1"/>
    <rect x="6" y="8" width="1" height="1"/><rect x="10" y="8" width="1" height="1"/>
  </svg>
);
const ActivityIcon = () => (
  <svg width="19" height="19" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="0" y="6" width="2" height="1"/><rect x="2" y="4" width="1" height="2"/>
    <rect x="3" y="2" width="1" height="2"/><rect x="4" y="4" width="1" height="2"/>
    <rect x="5" y="6" width="1" height="2"/><rect x="6" y="8" width="1" height="2"/>
    <rect x="7" y="6" width="1" height="2"/><rect x="8" y="6" width="4" height="1"/>
  </svg>
);
const StudioIcon = () => (
  <svg width="19" height="19" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="9" y="0" width="2" height="2"/><rect x="8" y="2" width="2" height="2"/>
    <rect x="7" y="3" width="2" height="2"/><rect x="6" y="4" width="2" height="2"/>
    <rect x="5" y="5" width="2" height="2"/><rect x="4" y="6" width="2" height="2"/>
    <rect x="3" y="7" width="2" height="2"/><rect x="2" y="8" width="2" height="2"/>
    <rect x="1" y="9" width="2" height="2"/><rect x="0" y="10" width="2" height="2"/>
    <rect x="0" y="9" width="1" height="1"/><rect x="10" y="2" width="1" height="1"/>
  </svg>
);
const ProfileIcon = () => (
  <svg width="19" height="19" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="4" y="1" width="4" height="4"/><rect x="5" y="5" width="2" height="1"/>
    <rect x="3" y="7" width="6" height="1"/><rect x="2" y="8" width="8" height="1"/>
    <rect x="1" y="9" width="10" height="3"/>
  </svg>
);
const PointsIcon = () => (
  <svg width="19" height="19" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="2" y="8" width="2" height="3"/><rect x="5" y="5" width="2" height="6"/>
    <rect x="8" y="2" width="2" height="9"/>
  </svg>
);
const DocsIcon = () => (
  <svg width="19" height="19" viewBox="0 0 12 12" fill="currentColor" style={{display:'block',shapeRendering:'crispEdges',opacity:0.92}} aria-hidden="true">
    <rect x="2" y="0" width="5" height="1"/><rect x="2" y="1" width="1" height="10"/>
    <rect x="3" y="11" width="7" height="1"/><rect x="9" y="3" width="1" height="8"/>
    <rect x="7" y="1" width="1" height="1"/><rect x="8" y="2" width="1" height="1"/>
    <rect x="7" y="0" width="2" height="1"/><rect x="8" y="1" width="2" height="1"/>
    <rect x="4" y="5" width="4" height="1"/><rect x="4" y="8" width="4" height="1"/>
  </svg>
);

const navItems = [
  { href: '/', label: 'Launchpad', Icon: DiscoverIcon },
  { href: '/collections', label: 'Collections', Icon: CollectionsIcon },
  { href: '/bridge', label: 'Bridge', Icon: BridgeIcon },
  { href: '/activity', label: 'Activity', Icon: ActivityIcon },
  { href: '/studio', label: 'Studio', Icon: StudioIcon },
  { href: '/my', label: 'Profile', Icon: ProfileIcon },
  { href: '/points', label: 'Points', Icon: PointsIcon },
  { href: '/verify', label: 'Docs', Icon: DocsIcon },
];

export default function Sidebar() {
  return (
    <div className="rail-slot" style={{flex:'0 0 64px',position:'sticky',top:0,height:'100vh'}}>
      <div
        data-sb="1"
        style={{
          position:'absolute',left:0,top:0,bottom:0,
          borderRight:'1px solid var(--line)',
          display:'flex',flexDirection:'column',
          padding:'16px 11px 16px 12px',
          background:'linear-gradient(180deg,#141415,#101011)',
          overflow:'hidden'
        }}
      >
        <Link href="/" style={{padding:'2px 2px 22px 1px',whiteSpace:'nowrap',display:'flex',alignItems:'center',gap:10}}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="https://zecbit.net/zb-logo.png" alt="ZecBit" width={38} height={18} style={{width:38,height:'auto',imageRendering:'pixelated',display:'block',flex:'0 0 auto'}} />
          <span className="sblab" style={{fontFamily:'var(--pixel)',fontSize:13,color:'var(--gold)',letterSpacing:1}}>ZECBIT</span>
        </Link>
        <nav style={{display:'flex',flexDirection:'column',gap:6}}>
          {navItems?.map(({href,label,Icon}) => (
            <Link
              key={href}
              href={href}
              className="hov-nav"
              style={{
                position:'relative',display:'flex',alignItems:'center',gap:13,
                background:'transparent',fontFamily:'var(--sans)',fontSize:13,fontWeight:500,
                padding:10,borderRadius:999,color:'rgba(228,228,229,.55)',
                transition:'color .18s ease, background .18s ease',overflow:'hidden'
              }}
            >
              <span style={{width:20,height:20,flex:'0 0 auto',display:'flex',alignItems:'center',justifyContent:'center',color:'rgba(228,228,229,.5)'}}>
                <Icon />
              </span>
              <span className="sblab" style={{whiteSpace:'nowrap'}}>{label}</span>
            </Link>
          ))}
        </nav>
        <div style={{flex:1,minHeight:16}} />
        <div className="sblab" style={{fontFamily:'var(--mono)',fontSize:10,lineHeight:1.6,color:'rgba(228,228,229,.3)',whiteSpace:'nowrap',marginTop:10}}>
          Private by default.<br/>Zcash · ZSA
        </div>
      </div>
      <div className="rail-scrim" aria-hidden="true" />
    </div>
  );
}
